import { useCallback } from 'react';

import { ViewerAiModule } from '@vimeo/ai-action-menu';
import { Flex } from '@vimeo/bokeh';
import { useLayout } from '@vimeo/clip-ui/hooks/use-layout';

import { useLoginModal } from '../hooks/use-login-modal';

interface VimeoAiModuleProps {
  clipId: string;
  clipRequestId: string;
}

export const VimeoAiModule = ({ clipId, clipRequestId }: VimeoAiModuleProps) => {
  const { onClose } = useLayout();
  const { toggleLoginModal, setRedirectUrl } = useLoginModal();

  const onLoginRequired = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.append('open_ai', 'true');
    setRedirectUrl(url.toString());
    toggleLoginModal(true);
  }, [setRedirectUrl, toggleLoginModal]);

  const onMomentPlay = useCallback((timecode: number) => {
    const iframe = document.querySelector<HTMLIFrameElement>('.viewer-showcase-player iframe');
    if (iframe && window.Vimeo?.Player) {
      const player = new window.Vimeo.Player(iframe);
      player.setCurrentTime(timecode);
      player.play();
    }
  }, []);

  return (
    <Flex direction="column" w="100%" h="100%" data-testid="ai-module">
      <ViewerAiModule
        pageName="viewer_home"
        videoId={Number(clipId)}
        videoRequestId={clipRequestId}
        onClose={onClose}
        onMomentPlay={onMomentPlay}
        onLoginRequired={onLoginRequired}
      />
    </Flex>
  );
};
